import React from 'react';
import AboutHeader from '../components/AboutHeader';
import Rating from '../components/RatingTable';

const AdminRatingPage: React.FC = () => {
  return (
    <div className='admin-rating'>
      <AboutHeader />
      <Rating />
    </div>
  );
}

export default AdminRatingPage;